import permissionDeniedImg from 'assets/images/permission_denied.svg';

import { ExclamationIcon } from '@heroicons/react/outline';
import { Link, useHistory } from 'react-router-dom';

const NotFound = () => {
  const history = useHistory();

  return (
    <div>
      <div className="w-full">
        <div className="p-2 rounded-lg bg-red-500 shadow-lg sm:p-3">
          <div className="flex items-center justify-between flex-wrap">
            <div className="w-0 flex-1 flex items-center">
              <span className="flex p-2 rounded-lg bg-red-600">
                <ExclamationIcon
                  className="h-6 w-6 text-white"
                  aria-hidden="true"
                />
              </span>
              <p className="ml-3 font-medium text-white text-sm truncate">
                <span>
                  Whoops!! You have provided an invalid request. Please contact
                  administrator
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 sm:mt-16 sm:mx-auto sm:w-full sm:max-w-sm">
        <img alt="permission-denied" src={permissionDeniedImg} />
      </div>
      <div className="mt-4 sm:mt-16 sm:mx-auto sm:w-full sm:max-w-sm text-center">
        <button
          type="button"
          className="py-2 px-12 tracking-widest rounded-3xl text-base bg-red-500 font-bold text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          onClick={() => history.goBack()}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
